import React, { useState, useEffect } from "react";
import { Button, Form } from "semantic-ui-react";
import messages from "./messages";
import styles from "./styles.module.scss";
import { FormattedMessage } from "react-intl";
import { get, put } from "utils/requests";
import { connect } from "react-redux";
import { legit } from "apex-legit-service";
import { RootState, RootAction } from "StoreTypes";
import { Dispatch, bindActionCreators } from "redux";
import { LEGIT_SERVICE_CONFIG } from "common";
import { removeApiToken } from "components/APITokenPersistence";
import { apiToken } from "../../services/legit/token";

export interface Props {
  endpoint: string;
  token: string | null;
  riskType: string;
  riskLevel: string;
  logout: () => void;
}

const RiskThresholdForm = ({
  endpoint,
  riskType,
  riskLevel,
  token,
  logout,
}: Props) => {
  const [threshold, setThreshold] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [complete, setComplete] = useState(false);
  const [headers] = useState(
    new Headers({
      "Content-Type": "application/json",
      Authorization: token as string,
    })
  );

  useEffect(() => {
    //loading
    get(endpoint, headers)
      .then((res) => {
        // This is never called
        setThreshold(res.value);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          removeApiToken();
          logout();
        }
        setLoading(false);
        setError(true);
      });
  }, [endpoint, headers, logout]);

  function updateThreshold() {
    const req = `{"value": "${threshold}"}`;
    put(`${endpoint}/${threshold}`, req, headers, true)
      .then(() => {
        // This is never called
        setComplete(true);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          removeApiToken();
          logout();
        }
        setError(true);
      });
  }

  return (
    <div className={styles.thresholdForm}>
      <div className={`ui ${loading ? "loading" : ""} form`}>
        <Form
          className={styles.title}
          onSubmit={updateThreshold}
          disabled={error}
        >
          <Form.Input
            value={threshold}
            type="number"
            id={`threshold-form-${riskType}-${riskLevel}-input`}
            label={<FormattedMessage {...messages.threshold} />}
            onChange={(e) => setThreshold(e.currentTarget.value)}
          />
          <Button
            id={`threshold-form-${riskType}-${riskLevel}-submit`}
            type="submit"
            disabled={error}
          >
            <FormattedMessage {...messages.submit} />
          </Button>
        </Form>
      </div>
      {complete && (
        <div
          className="ui success message"
          id={`threshold-${riskType}-${riskLevel}-success`}
        >
          <div className="header">
            <FormattedMessage {...messages.success} />
          </div>
        </div>
      )}
      {error && (
        <div
          className="ui error message"
          id={`threshold-${riskType}-${riskLevel}-error`}
        >
          <div className="header">
            <FormattedMessage {...messages.errorHeader} />
          </div>
          <p>
            <FormattedMessage {...messages.errorBody} />
          </p>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: apiToken(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) =>
  bindActionCreators(
    {
      logout: () => legit.logout(LEGIT_SERVICE_CONFIG, { apexUser: true }),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RiskThresholdForm);
